import { Box, Typography } from '@mui/material';
import { PatientServiceItem, PatientServiceItemStatus, PaymentTypeName, ServiceItemPaymentStatus } from '@uplift/api';
import { MoneyCents } from '@uplift/ui-v2';


export const ServiceItemPaymentAmount = ({ row, label }: { row: PatientServiceItem; label?: string }) => {
  if (row.payment?.type === PaymentTypeName.insurance && [ PatientServiceItemStatus.processing ].includes(row.status)) {
    return (
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        {label}
        <span>TBD</span>
      </Box>
    );
  }

  if (!row.payment) {
    return <span>No charge</span>;
  }

  if (!row.payment.payment?.amountCents) {
    return <span>No charge</span>;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      {label}
      <strong><MoneyCents value={row.payment.payment?.amountCents} /></strong>
    </Box>
  );
};


export const CompletedServiceItemPaymentAmount = ({ row }: { row: PatientServiceItem }) => {
  if (row.payment?.status === ServiceItemPaymentStatus.unknown) {
    return <Box display="flex" flexDirection="column" alignItems="flex-end">Unavailable</Box>;
  }

  if (row.payment?.status === ServiceItemPaymentStatus.canceled) {
    return <Box display="flex" flexDirection="column" alignItems="flex-end">No charge</Box>;
  }

  if (row.payment?.status === ServiceItemPaymentStatus.refunded) {
    return (
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        <Typography variant="body2" color="textPrimary" style={{ textDecoration: 'line-through' }}><MoneyCents value={row.payment.payment?.amountCents} /></Typography>
        <Typography variant="body2" color="textSecondary">Refunded</Typography>
      </Box>
    );
  }

  return (
    <ServiceItemPaymentAmount row={row} label="Paid" />
  );
};

